import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IGBPFormMeta {
    indexDataB: FormInputMeta;
    lengthDataB: FormInputMeta;

}

const gbpFormMeta = {} as IGBPFormMeta;

gbpFormMeta.indexDataB = {
    name: "indexDataB",
    type: "number",
    label: "Index Données B",
    placeholder: "",
    validation: yup.number()
};

gbpFormMeta.lengthDataB = {
    name: "lengthDataB",
    type: "number",
    label: "Longueur Données B",
    placeholder: "",
    validation: yup.number()
};


export default gbpFormMeta;